import { useMemo } from "react";
import type { WovarProduct } from "@commercekit/api";

export const useWovarProductMarketingSticker = (
  product: WovarProduct | null,
  stickerName: string = "WVR1_Marketing_Marketing_sticker"
) => {
  const marketingSticker = useMemo(
    () =>
      product
        ? product.marketingProperties?.find(
            (property) => property?.name === stickerName
          )
        : null,
    [product, stickerName]
  );

  const stickerTitle = useMemo(
    () =>
      marketingSticker && marketingSticker?.value?.stringValue
        ? marketingSticker?.value?.stringValue
        : "",
    [marketingSticker]
  );

  return { marketingSticker, stickerTitle };
};
